import { Components } from "@mui/material/styles/components";
import { Grey, White } from "@themes:palette";

export default {
  MuiTextField: {
    defaultProps: {
      size: "small",
    },
    styleOverrides: {
      root: {
        borderRadius: 7,
        borderWidth: 0,
        input: {
          borderRadius: 7,
        },
        "&.with-bg": {
          backgroundColor: Grey[50],
          "& .MuiOutlinedInput-input:focus": {
            backgroundColor: White,
          },
          ":has(.Mui-focused)": {
            backgroundColor: White, // important to set bg color when focused
          },
        },
        "& .MuiOutlinedInput-root": {
          borderRadius: 7,
          fieldset: {
            borderWidth: 0,
          },
        },
      },
    },
  } as Components["MuiTextField"],
};
